__webpack_require__.p =(() => {
          if (window.location.host.startsWith('local') && !document.currentScript.src.includes('local')) {
            return new URL(document.currentScript.src).origin + '/assets/exo/793/';
          } else {
            return '/assets/exo/793/';
          }
        })();